export default __webpack_public_path__ + "static/media/S0020_6.13_TST_algorithm.1702919280000.9351fcdd.jpg";